import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { BotService } from 'src/app/services/bot.service';

@Component({
  selector: 'app-arbitrage-profit',
  templateUrl: './arbitrage-profit.component.html',
  styleUrls: ['./arbitrage-profit.component.css']
})
export class ArbitrageProfitComponent {

profitData: any = [];

intervalId:any;

constructor(private http: HttpClient, private service: BotService) {}

  
ngOnInit() {
   //this.getBinancePrice('POL', 'USDT');
   this.intervalId = setInterval(() => this.fetchAllPrices(), 5000); 
  }
  
  fetchAllPrices() {
    this.service.getArbitrageProfit().subscribe(
      (res: any) => {
        const lines = res?.result?.lines || [];
  
        const parsedData = lines.map((line: string) => {
          const [time, pair, buyPart, sellPart, profitPart] = line.split(' | ');
  
          const buyMatch = /BUY from (\w+) at \$([\d.]+)/.exec(buyPart);
          const sellMatch = /SELL to (\w+) at \$([\d.]+)/.exec(sellPart);
          const profitMatch = /Profit: \$([\d.]+)/.exec(profitPart);
  
          return {
            time,
            pair,
            buyExchange: buyMatch?.[1] || '',
            buyPrice: parseFloat(buyMatch?.[2] || '0'),
            sellExchange: sellMatch?.[1] || '',
            sellPrice: parseFloat(sellMatch?.[2] || '0'),
            profit: parseFloat(profitMatch?.[1] || '0')
          };
        });
  
        // Keep only the last 10 entries
        this.profitData = parsedData.slice(-10);
  
        console.log('Parsed profit data (last 10):', this.profitData, res);
      },
      (error: any) => {
        console.error('Error fetching profit data:', error);
      }
    );
  }


}